import React from 'react';
import Separator from '@discover-ui/separator';
import ReviewCard, { type ReviewCardProps } from './ReviewCard';
import type { ReviewReply } from './types';

export type ReviewProps = Omit<ReviewCardProps, 'name' | 'comment' | 'date' | 'userType'>;

const hasComment = (reply: ReviewReply | null): reply is ReviewReply => Boolean(reply?.comment);

export default function Review({ nameAccessory, ...props }: ReviewProps) {
  const { review } = props;
  const replies = review.replies?.filter(hasComment) ?? [];

  return (
    <>
      <ReviewCard
        {...props}
        nameAccessory={nameAccessory}
        name={review.name}
        comment={review.comment}
        date={review.dinedDate}
      />
      {replies.length > 0 && (
        <>
          <Separator />
          {replies.map((reply) => (
            <ReviewCard
              key={reply.id}
              ml={[20, 80]}
              {...props}
              name={reply.name}
              comment={reply.comment}
              date={reply.date}
              userType={reply.userType}
            />
          ))}
        </>
      )}
    </>
  );
}
